import { Illustration, Text, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { ProductTransactionFlow } from '../../../../../store/transactionFlow/types';

export interface ProductTableProps {
  product: ProductTransactionFlow;
  onSelectClient: (cpfCnpj: string) => void;
}

export interface ProductFieldProps<T> {
  key: keyof T;
  label: string;
}

export const NotFoundTable = () => (
  <VStack alignItems="center" paddingY={Spacing['stack.lg']}>
    <VStack alignItems="center" space={Spacing['stack.quarck']}>
      <Illustration name="NotFoundIllustration" testId="empty-illustration" />
      <Text color="neutral.black" variant="semibold">
        Não há movimentações disponíveis.
      </Text>
      <Text color="neutral.black">
        Seus clientes não possuem movimentações disponíveis na data atual.
      </Text>
    </VStack>
  </VStack>
);
